// https://docs.appcues.com/article/161-javascript-api
export var AppCuesEvents;
(function (AppCuesEvents) {
    AppCuesEvents["FlowStarted"] = "flow_started";
    AppCuesEvents["FlowCompleted"] = "flow_completed";
    AppCuesEvents["FlowSkipped"] = "flow_skipped";
    AppCuesEvents["StepInteracted"] = "step_interacted";
    AppCuesEvents["FormSubmitted"] = "form_submitted";
    AppCuesEvents["FormFieldSubmitted"] = "form_field_submitted";
})(AppCuesEvents || (AppCuesEvents = {}));
export class AppCuesService {
    constructor() {
        this.registeredEvents = {};
        if (AppCuesService._instance) {
            throw new Error('AppCuesService is a singleton. Use instance property instead of constructor');
        }
    }
    /**
     * Returns a singleton instance
     */
    static get instance() {
        AppCuesService._instance =
            AppCuesService._instance || new AppCuesService();
        return AppCuesService._instance;
    }
    /**
     * Identify user and add it to singleton class
     * @param args Appcues identify params
     */
    identify(...args) {
        if (typeof Appcues !== 'undefined') {
            Appcues.identify(...args);
        }
    }
    /**
     * Start AppCues on page
     */
    start() {
        if (typeof Appcues !== 'undefined') {
            Appcues.start();
        }
    }
    /**
     * Executes a callback based on a flow event
     * @param event The event that happened (started, completed, etc.)
     * @param flowId The id of AppCues flow
     * @param callback The method that shold be executed
     */
    onEvent(event, flowId, callback) {
        if (!Appcues) {
            return;
        }
        if (this.registeredEvents[event] === undefined) {
            Appcues.on(event, async (appCuesEvent) => {
                if (this.registeredEvents[appCuesEvent.id] && this.registeredEvents[appCuesEvent.id][appCuesEvent.flowId]) {
                    await this.registeredEvents[appCuesEvent.id][appCuesEvent.flowId](appCuesEvent);
                }
            });
        }
        this.registeredEvents[event] = { ...this.registeredEvents[event], [flowId]: callback };
    }
    /**
     * Remove a callback execution based on a flow event
     * @param event The event that happened (started, completed, etc.)
     * @param flowId The id of AppCues flow
     */
    offEvent(event, flowId) {
        if (!Appcues) {
            return;
        }
        if (this.registeredEvents[event] && this.registeredEvents[event][flowId]) {
            this.registeredEvents[event][flowId] = undefined;
        }
    }
}
